import PropTypes from "prop-types"
import React from 'react'
import intl from 'react-intl-universal'
import moment from 'moment'
import { formatNumber } from 'utils/format'

const verifyUpdated = (previous, current) => previous !== current

const AceiteAtualizado = ({ data }) => (
  <div style={{ marginLeft: '40px', marginBottom: '10px' }}>
    {
      verifyUpdated(data.QuantidadeAnterior, data.Quantidade) &&
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.previousQty')}</span>
          <span>{formatNumber(data.QuantidadeAnterior)}</span>
        </div>
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.currentQty')}</span>
          <span>{formatNumber(data.Quantidade)}</span>
        </div>
      </div>
    }
    {
      verifyUpdated(data.DataColetaAnterior, data.DataColetaPrevista) &&
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.previousCollectDate')}</span>
          <span>{moment(data.DataColetaAnterior).format('L')}</span>
        </div>
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.collectDate')}</span>
          <span>{moment(data.DataColetaPrevista).format('L')}</span>
        </div>
      </div>
    }
    {
      verifyUpdated(data.DataEntregaAnterior, data.DataEntregaPrevista) &&
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.previousDeliveryDate')}</span>
          <span>{moment(data.DataEntregaAnterior).format('L')}</span>
        </div>
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.deliveryDate')}</span>
          <span>{moment(data.DataEntregaPrevista).format('L')}</span>
        </div>
      </div>
    }
    {
      verifyUpdated(data.MaterialDescricaoAnterior, data.MaterialDescricao) &&
      <React.Fragment>
        <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.previousMaterial')}</span>
            <span>{data.MaterialDescricaoAnterior}</span>
          </div>
        </div>
        <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.material')}</span>
            <span>{data.MaterialDescricao}</span>
          </div>
        </div>
      </React.Fragment>
    }
    {
      verifyUpdated(data.NomeFornecedorAnterior, data.NomeFornecedor) &&
      <React.Fragment>
        <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.previousSupplier')}</span>
            <span>{data.NomeFornecedorAnterior}</span>
          </div>
        </div>
        <div className="negotiation-read-offer">
          <div className="negotiation-read-column">
            <span>{intl.get('stocks.timeline.supplier')}</span>
            <span>{data.NomeFornecedor}</span>
          </div>
        </div>
      </React.Fragment>
    }
    {data.TypeJustificationManualSuggestionDescription && 
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          <span>{intl.get('stocks.timeline.justification')}</span>
          <span>{data.TypeJustificationManualSuggestionDescription}</span>
        </div>
      </div>
    }
  </div>
)

AceiteAtualizado.propTypes = {
  data: PropTypes.shape({
    DataColetaAnterior: PropTypes.any,
    DataColetaPrevista: PropTypes.any,
    DataEntregaAnterior: PropTypes.any,
    DataEntregaPrevista: PropTypes.any,
    MaterialDescricao: PropTypes.any,
    MaterialDescricaoAnterior: PropTypes.any,
    NomeFornecedor: PropTypes.any,
    NomeFornecedorAnterior: PropTypes.any,
    Quantidade: PropTypes.any,
    QuantidadeAnterior: PropTypes.any,
    TypeJustificationManualSuggestionDescription: PropTypes.string
  }).isRequired
}

export default AceiteAtualizado
